export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'Приложение',
            'horizontal': 'горизонтальный',
            'horizontalMenu': 'горизонтальное меню',
            'general': 'Генеральная',
            'component': 'Компонент',
            'features': 'Особенности',
            'applications': 'Приложения',
            'dashboard': 'приборная доска',
            'dashboard1': 'Панель приборов 1',
            'modules': 'Модули',
            'agency': 'Агентство',
            'pages': 'страницы',
            'gallery': 'Галерея',
            'pricing': 'ценообразование',
            'terms&Conditions': 'Условия Условия',
            'feedback': 'Обратная связь',
            'report': 'отчет',
            'faq(s)': 'задаваемые вопросы (ы)',
            'advancedComponent': 'Расширенный компонент',
            'blank': 'пустой',
            'session': 'сессия',
            'login': 'Авторизоваться',
            'register': 'регистр',
            'lockScreen': 'Экран блокировки',
            'forgotPassword': 'Забыли пароль',
            'uiComponents': 'Компоненты пользовательского интерфейса',
            'alerts': 'Оповещения',
            'appBar': 'Панель приложений',
            'avatars': 'Аватары',
            'buttons': 'Кнопки',
            'bottomNavigations': 'Нижние навигационные',
            'badges': 'Значки',
            'cards': 'Карты',
            'cardsMasonry': 'Карточки Masonry',
            'chip': 'чип',
            'dialog': 'диалог',
            'dividers': 'циркуль',
            'drawers': 'подштанники',
            'popover': 'Трещать',
            'expansionPanel': 'Панель расширения',
            'gridList': 'Сетка Список',
            'list': 'Список',
            'menu': 'Меню',
            'popoverAndToolTip': 'поп Нада также Инструмент наконечник',
            'progress': 'Прогресс',
            'snackbar': 'Закусочная',
            'selectionControls': 'Контроль выбора',
            'advanceUiComponents': 'Дополнительные компоненты пользовательского интерфейса',
            'dateAndTimePicker': 'Выбор даты и времени',
            'tabs': 'Вкладки',
            'stepper': 'Шаговый',
            'notification': 'уведомление',
            'sweetAlert': 'Сладкое предупреждение',
            'autoComplete': 'Автозаполнение',
            'aboutUs': 'О нас',
            'widgets': 'Виджеты',
            'inbox': 'входящие',
            'forms': 'формы',
            'formElements': 'Элементы формы',
            'textField': 'Текстовое поле',
            'selectList': 'Выбрать список',
            'charts': 'Графики',
            'reCharts': 'диаграммы',
            'reactChartjs2': 'Реакция Chartjs 2',
            'icons': 'Иконки',
            'themifyIcons': 'Имитировать значки',
            'simpleLineIcons': 'Иконки простой линии',
            'materialIcons': 'Иконки материалов',
            'fontAwesome': 'Шрифт Awesome',
            'maps': 'Карты',
            'googleMaps': 'Карты Гугл',
            'leafletMaps': 'Листовые карты',
            'tables': 'таблицы',
            'basic': 'основной',
            'dataTable': 'Таблица данных',
            'reactTable': 'Таблица реактивов',
            'responsive': 'отзывчивый',
            'userList': 'Список пользователей',
            'users': 'пользователей',
            'userProfile1': 'Профиль пользователя 1',
            'userProfile2': 'Профиль пользователя 2',
            'userManagement': 'Управление пользователями',
            'userProfile': 'Профиль пользователя',
            'calendar': 'Календарь',
            'cultures': 'Культуры',
            'dnd': 'просьба не беспокоить',
            'selectable': 'Выбор',
            'customRendering': 'Пользовательский рендеринг',
            'chat': 'чат',
            'toDo': 'Делать',
            'editor': 'редактор',
            'wysiwygEditor': 'Редактор WYSIWYG',
            'quillEditor': 'Редактор Quill',
            'reactAce': 'Реагировать Ace',
            'dragAndDrop': 'Перетаскивание',
            'reactDragula': 'Реагировать на Драгулу',
            'reactDnd': 'Реагировать на Dnd',
            'blogManagement': 'Управление блогами',
            'ecommerce': 'Электронная торговля',
            'shopList': 'Список магазинов',
            'shopGrid': 'Сеть магазинов',
            'invoice': 'Выставленный счет',
            'multilevel': 'многоуровневый',
            'sublevel': 'Подуровень',
            'dateTimePicker': 'Выбор даты и времени',
            'user': 'пользователь',
            'miscellaneous': 'Разное',
            'promo': 'рекламный',
            'gettingStarted': 'Начиная',
            'shop': 'Магазин',
            'cart': 'телега',
            'checkout': 'Проверять, выписываться',
            'saas': 'SAAS',
            'multiLevel': 'MultiLevel',
            'level1': '1-й уровень',
            'level2': 'Уровень 2',
            'boxed': 'в штучной упаковке',
            'news': 'Новости',
            'extensions': 'расширения',
            'imageCropper': 'Изображение Cropper',
            'videoPlayer': 'Видео проигрыватель',
            'dropzone': 'Зона сброса',
            'crm': 'CRM',
            'projects': 'проектов',
            'projectDetail': 'Деталь проекта',
            'clients': 'клиенты',
            'reports': 'отчеты'
        },
        'widgets': {
            'totalEarns': 'Всего заработает',
            'emailsStatistics': 'Статистика электронной почты',
            'totalRevenue': 'Общий доход',
            'onlineVistors': 'Интернет-висторы',
            'trafficSources': 'Источники трафика',
            'RecentOrders': 'Недавние заказы',
            'topSellings': 'Лучшие продажи',
            'productReports': 'Отчеты о продукции',
            'productStats': 'Статистика продукта',
            'ComposeEmail': 'Написать письмо',
            'employeePayroll': 'Заработная плата сотрудников',
            'visitors': 'Посетители',
            'orders': 'заказы',
            'orderStatus': 'Статус заказа',
            'totalSales': 'Тотальная распродажа',
            'netProfit': 'Чистая прибыль',
            'overallTrafficStatus': 'Общее состояние трафика',
            'tax': 'налог',
            'expenses': 'РАСХОДЫ',
            'currentTime': 'Текущее время',
            'currentDate': 'Текущая дата',
            'todayOrders': 'Сегодня заказы',
            'toDoList': 'Сделать списки',
            'discoverPeople': 'Откройте для себя людей',
            'commments': 'Комментарии',
            'newCustomers': 'новые клиенты',
            'recentNotifications': 'Последние уведомления',
            'appNotifications': 'Уведомления приложений',
            'newEmails': 'Новые электронные письма',
            'siteVisitors': 'Посетители сайта',
            'recentActivities': 'Последние действия',
            'recentOrders': 'Недавние заказы',
            'gallery': 'Галерея',
            'pricing': 'ценообразование',
            'enterpriseEdition': 'Enterprise Edition',
            'personalEdition': 'Персональная версия',
            'teamEdition': 'Командный выпуск',
            'ratings': 'Рейтинги',
            'socialCompanines': 'Социальные компании',
            'standard': 'стандарт',
            'advanced': 'продвинутый',
            'master': 'Мастер',
            'Mega': 'Мега',
            'logIn': 'Авторизоваться',
            'signUp': 'Зарегистрироваться',
            'lockScreen': 'Экран блокировки',
            'alertsWithLink': 'Оповещения с ссылкой',
            'additionalContent': 'Дополнительный контент',
            'alertDismiss': 'Оповещение об увольнении',
            'uncontrolledDisableAlerts': 'Неконтролируемые отключенные оповещения',
            'contexualAlerts': 'Контекстные оповещения',
            'alertsWithIcons': 'Оповещения с иконками',
            'Simple App Bars': 'Sобновить App Bars',
            'appBarsWithButtons': 'Панель приложений с кнопками',
            'imageAvatars': 'Iмага Аватары',
            'lettersAvatars': 'Письма Аватары',
            'iconsAvatars': 'Иконки Аватары',
            'flatButtons': 'Плоские кнопки',
            'raisedButton': 'Поднятая кнопка',
            'buttonWithIconAndLabel': 'Кнопка с иконкой и ярлыком',
            'floatingActionButtons': 'Плавающие кнопки действий',
            'iconButton': 'Кнопка значка',
            'socialMediaButton': 'Кнопка Социальные медиа',
            'reactButton': 'Кнопка ответа',
            'buttonOutline': 'Контур кнопки',
            'buttonSize': 'Размер кнопки',
            'buttonState': 'Состояние кнопки',
            'buttonNavigationWithNoLabel': 'Кнопка Навигация без метки',
            'buttonNavigation': 'Навигация по кнопке',
            'iconNavigation': 'Навигация по иконкам',
            'badgeWithHeadings': 'BПрикрепленное изображение с заголовками',
            'contexualVariations': 'Контекстные вариации',
            'badgeLinks': 'Ссылки на значки',
            'materialBadge': 'Значок материала',
            'simpleCards': 'Простые карты',
            'backgroundVarient': 'Справочная информация',
            'cardOutline': 'План карты',
            'overlayCard': 'Карта наложения',
            'cardGroup': 'Группа карт',
            'cardTitle': 'Название карты',
            'speacialTitleTreatment': 'Юридическая информация',
            'chipWithClickEvent': 'Чип с кликом',
            'chipArray': 'Чип-массив',
            'dialogs': 'Диалоги',
            'listDividers': 'Список разделителей',
            'insetDividers': 'Вставляемые разделители',
            'temporaryDrawers': 'Временные ящики',
            'permanentDrawers': 'Постоянные ящики',
            'simpleExpansionPanel': 'Простая панель расширения',
            'controlledAccordion': 'Контролируемый аккордеон',
            'secondaryHeadingAndColumns': 'Вторичные заголовки и столбцы',
            'imageOnlyGridLists': 'Только списки гридов',
            'advancedGridLists': 'Расширенные списки гридов',
            'singleLineGridLists': 'Однолинейные списки сетки',
            'simpleLists': 'Простые списки',
            'folderLists': 'Списки папок',
            'listItemWithImage': 'Список элементов с изображением',
            'switchLists': 'Списки переключателей',
            'insetLists': 'Списки вставки',
            'nestedLists': 'Вложенные списки',
            'checkboxListControl': 'Контроль списка флажков',
            'pinedSubHeader': 'Выровненный подзаголовок',
            'InteractiveLists': 'Интерактивные списки',
            'simpleMenus': 'Простые меню',
            'selectedMenu': 'Выбранное меню',
            'maxHeightMenu': 'Меню максимальной высоты',
            'changeTransition': 'Изменить переход',
            'paper': 'Бумага',
            'anchorPlayGround': 'Якорная игровая площадка',
            'tooltip': 'ToolTip',
            'positionedToolTips': 'Расположенная закусочная',
            'circularProgressBottomStart': 'Круговой ход',
            'interactiveIntegration': 'Интерактивная интеграция',
            'determinate': 'детерминированный',
            'linearProgressLineBar': 'Линейная линия линейки хода',
            'indeterminate': 'неопределенный',
            'buffer': 'буфер',
            'query': 'запрос',
            'transitionControlDirection': 'Направление управления переключением',
            'simpleSnackbar': 'Простая закусочная',
            'positionedSnackbar': 'Расположенная закусочная',
            'contexualColoredSnackbars': 'Контекстные цветные закусочные',
            'simpleCheckbox': 'Простой флажок',
            'interminateSelection': 'Межминистерский отбор',
            'disabledCheckbox': 'Отключен флажок',
            'customColorCheckbox': 'Пользовательский флажок цвета',
            'VerticalStyleCheckbox': 'Флажок вертикального стиля',
            'horizontalStyleCheckbox': 'Флажок горизонтального стиля',
            'radioButtons': 'Радио-кнопки',
            'disabledRadio': 'Отключенное радио',
            'withError': 'С ошибкой',
            'switches': 'Swiches',
            'dateAndTimePicker': 'Выбор даты и времени',
            'defaultPicker': 'Выбор по умолчанию',
            'timePicker': 'Выбор времени',
            'weekPicker': 'Выбор недели',
            'defaultDatePicker': 'Выбор даты по умолчанию',
            'customPicker': 'Пользовательский подборщик',
            'tabs': 'Вкладки',
            'fixedTabs': 'Фиксированные вкладки',
            'basicTab': 'Основная вкладка',
            'centeredLabels': 'Центрированные ярлыки',
            'forcedScrolledButtons': 'Принудительные кнопки прокрутки',
            'iconsTabs': 'Вкладки вкладок',
            'withDisableTabs': 'С отключенными вкладками',
            'iconWithLabel': 'Иконка с меткой',
            'stepper': 'Шаговый',
            'horizontalLinear': 'Горизонтальная линейная',
            'horizontalNonLinear': 'Горизонтальный нелинейный',
            'horizontalLinerAlternativeLabel': 'Альтернативная метка горизонтального вкладыша',
            'horizontalNonLinerAlternativeLabel': 'Горизонтальная альтернативная этикетка без вкладыша',
            'verticalStepper': 'Вертикальный степпер',
            'descriptionAlert': 'Описание Alert',
            'customIconAlert': 'Пользовательский значок оповещения',
            'withHtmlAlert': 'С Html бдительный',
            'promptAlert': 'Быстрое оповещение',
            'passwordPromptAlert': 'Предупреждение о запросе пароля',
            'customStyleAlert': 'Пользовательский стиль оповещения',
            'autoComplete': 'Автозаполнение',
            'reactSelect': 'Выбор реакции',
            'downshiftAutoComplete': 'Автоматический переход на пониженную передачу',
            'reactAutoSuggests': 'Реагировать на авто',
            'aboutUs': 'О нас',
            'ourVission': 'Наши деления',
            'ourMissions': 'Наши миссии',
            'ourMotivation': 'Наша мотивация',
            'defualtReactForm': 'Defualt React Form',
            'url': 'Веб-сайт',
            'textArea': 'Текстовая область',
            'file': 'файл',
            'formGrid': 'Сетка формы',
            'inlineForm': 'Встроенная форма',
            'inputSizing': 'Размер входного сигнала',
            'inputGridSizing': 'Ширина сетки ввода',
            'hiddenLabels': 'Скрытые ярлыки',
            'formValidation': 'Проверка формы',
            'number': 'Число',
            'date': 'Дата',
            'time': 'Время',
            'color': 'цвет',
            'search': 'Поиск',
            'selectMultiple': 'Выберите несколько',
            'inputWithSuccess': 'Вход с успехом',
            'inputWithDanger': 'Вход с опасностью',
            'simpleTextField': 'Простое текстовое поле',
            'componet': 'Компоненты',
            'layouts': 'Макеты',
            'inputAdorements': 'Входные адепты',
            'formattedInputs': 'Форматированные входы',
            'simpleSelect': 'Простой выбор',
            'nativeSelect': 'Нативный выбор',
            'MutltiSelectList': 'Выбрать список Mutlti',
            'lineChart': 'Линейный график',
            'barChart': 'Барная диаграмма',
            'stackedBarChart': 'Сложенная гистограмма',
            'lineBarAreaChart': 'Диаграмма площади линии',
            'areaChart': 'Диаграмма района',
            'stackedAreaChart': 'Сложенная область',
            'verticalChart': 'Вертикальная диаграмма',
            'radarChart': 'Радарная диаграмма',
            'doughnut': 'Пончик',
            'polarChart': 'Полярная диаграмма',
            'pieChart': 'Круговая диаграмма',
            'bubbleChart': 'Диаграмма пузырьков',
            'horizontalBar': 'Бар Horizonatl',
            'basicTable': 'Основная таблица',
            'contexualColoredTable': 'Контекстная цветная таблица',
            'dataTable': 'Таблица данных',
            'employeeList': 'Список сотрудников',
            'responsiveTable': 'Отзывчивая таблица',
            'responsiveFlipTable': 'Отзывчивый откидной стол',
            'reactGridControlledStateMode': 'Реагировать режим контролируемого состояния сетки',
            'googleMaps': 'Карты Гугл',
            'productsReports': 'Отчеты о продукции',
            'taskList': 'Список заданий',
            'basicCalender': 'Основной календарь',
            'culturesCalender': 'Календари культур',
            'dragAndDropCalender': 'Перетаскивание и удаление календаря',
            'selectableCalender': 'Выбираемый календарь',
            'customRendering': 'Пользовательский рендеринг',
            'customCalender': 'Пользовательский календарь',
            'searchMailList': 'Поиск в списке рассылки',
            'forgetPassword': 'Забыть пароль',
            'QuickLinks': 'Быстрые ссылки',
            'upgrade': 'Обновить',
            'app': 'Приложение',
            'addNew': 'Добавить новое',
            'orderDate': 'Дата заказа',
            'status': 'Положение дел',
            'trackingNumber': 'Номер Отслеживания',
            'action': 'действие',
            'designation': 'обозначение',
            'subject': 'предмет',
            'send': 'послать',
            'saveAsDrafts': 'Сохранить как черновики',
            'onlineSources': 'Интернет-источники',
            'lastMonth': 'Прошлый месяц',
            'widgets': 'Виджеты',
            'listing': 'список',
            'paid': 'оплаченный',
            'refunded': 'Возвращено',
            'done': 'Готово',
            'pending': 'в ожидании',
            'cancelled': 'отменен',
            'approve': 'Одобрить',
            'following': 'Следующий',
            'follow': 'следовать',
            'graphs&Charts': 'Графики и диаграммы',
            'open': 'открыто',
            'bounced': 'Возвращенные',
            'spam': 'Спам',
            'unset': 'Отозвать',
            'bandwidthUse': 'Использование полосы пропускания',
            'dataUse': 'Data использование',
            'unsubscribe': 'Отказаться от подписки',
            'profile': 'Профиль',
            'messages': 'Сообщения',
            'support': 'Поддержка',
            'faq(s)': 'Вопрос-ответ (ы)',
            'upgradePlains': 'Обновление равнин',
            'logOut': 'Выйти',
            'mail': 'почта',
            'adminTheme': 'Тема администратора',
            'wordpressTheme': 'Тема Wordpress',
            'addToCart': 'Добавить в корзину',
            'plan': 'План',
            'basic': 'основной',
            'pro': 'профессионал',
            'startToBasic': 'Начать к основным',
            'upgradeToPro': 'Обновление до Pro',
            'upgradeToAdvance': 'Обновление до продвинутого',
            'comparePlans': 'Сравнить планы',
            'free': 'Свободно',
            'frequentlyAskedQuestions': 'Часто задаваемые вопросы',
            'searchIdeas': 'Поиск идей',
            'startDate': 'Дата начала',
            'endDate': 'Дата окончания',
            'category': 'категория',
            'apply': 'Подать заявление',
            'downloadPdfReport': 'Загрузить отчет Pdf',
            'yesterday': 'Вчера',
            'totalOrders': 'Всего заказов',
            'totalVisitors': 'Всего посетителей',
            'typeYourQuestions': 'Введите ваши вопросы',
            'username': 'имя пользователя',
            'password': 'пароль',
            'signIn': 'Войти в систему',
            'enterYourPassword': 'Введите ваш пароль',
            'alreadyHavingAccountLogin': 'Уже есть учетная запись',
            'composeMail': 'Написать письмо',
            'issue': 'вопрос',
            'recentChat': 'Последние сообщения',
            'previousChat': 'Предыдущий чат',
            'all': 'Все',
            'filters': 'фильтры',
            'deleted': 'удаленный',
            'starred': 'Помеченные',
            'frontend': 'Внешний интерфейс',
            'backend': 'Backend',
            'api': 'Api',
            'simpleAppBar': 'Простая панель приложений',
            'recents': 'Недавние',
            'cardLink': 'Ссылка на карту',
            'anotherLink': 'Еще одна ссылка',
            'cardSubtitle': 'подзаголовок карты',
            'confirmationDialogs': 'Диалоги подтверждения',
            'deletableChip': 'Удаляемый чип',
            'customDeleteIconChip': 'Пользовательское удаление значка',
            'openAlertDialog': 'Открыть диалоговое окно оповещений',
            'openResponsiveDialog': 'Открыть ответный диалог',
            'openSimpleDialog': 'Открыть простой диалог',
            'openFormDialog': 'Диалог открытой формы',
            'follower': 'толкатель',
            'important': 'Важный',
            'private': 'Частный',
            'openLeft': 'Открыть влево',
            'openRight': 'Открыть право',
            'openTop': 'С открытым верхом',
            'openBottom': 'Открытое дно',
            'selectTripDestination': 'Выберите пункт назначения поездки',
            'pinnedSubheaderList': 'Список закрепленных подзаголовков',
            'singleLineItem': 'Одиночная позиция',
            'acceptTerms': 'Принять условия',
            'optionA': 'Вариант A',
            'optionB': 'Вариант B',
            'optionC': 'Вариант C',
            'optionM': 'Вариант M',
            'optionN': 'Вариант N',
            'optionO': 'Вариант O',
            'customColor': 'Пользовательский цвет',
            'centeredTabs': 'Центрированные вкладки',
            'multipleTabs': 'Несколько вкладок',
            'preventScrolledButtons': 'Запретить прокручиваемые кнопки',
            'browse': 'Просматривать',
            'formValidate': 'Форма подтверждения',
            'code': 'Код',
            'company': 'Компания',
            'price': 'Цена',
            'change': 'изменение',
            'high': 'Высокая',
            'low': 'Низкий',
            'volume': 'объем',
            'personalDetails': 'Личная информация',
            'occupation': 'оккупация',
            'companyName': 'название компании',
            'phoneNo': 'Номер телефона',
            'city': 'город',
            'zipCode': 'Почтовый Индекс',
            'updateProfile': 'Обновить профиль',
            'reject': 'отклонять',
            'exportToExcel': 'Экспорт в превосходить',
            'addNewUser': 'Добавить пользователя',
            'workWeek': 'Рабочая неделя',
            'agenda': 'Повестка дня',
            'conference': 'Конференция',
            'multilevel': 'многоуровневый',
            'dailySales': 'Ежедневные продажи',
            'today': 'Cегодня',
            'campaignPerformance': 'Эффективность кампании',
            'supportRequest': 'Запрос поддержки',
            'usersList': 'Список пользователей',
            'lastWeek': 'На прошлой неделе',
            'buyMore': 'Купить больше',
            'trafficChannel': 'Канал трафика',
            'stockExchange': 'Фондовая биржа',
            'tweets': 'твиты',
            'ourLocations': 'Наши местоположения',
            'sales': 'Продажи',
            'to': 'к',
            'shipTo': 'Адрес получателя',
            'description': 'Описание',
            'unitPrice': 'Цена за единицу',
            'total': 'Всего',
            'note': 'Заметка',
            'chipWithAvatar': 'Чип с аватаром',
            'chipWithTextAvatar': 'Чип с текстом Аватар',
            'chipWithIconAvatar': 'Чип с иконкой Аватар',
            'customClickableChip': 'Пользовательский клик-чип',
            'outlineChip': 'Контурный чип',
            'disableChip': 'Отключить чип',
            'alertDialog': 'Диалоговое окно оповещений',
            'animatedSlideDialogs': 'Анимированные слайд-диалоги',
            'fullScreenDialogs': 'Полноэкранные диалоги',
            'formDialogs': 'Диалоги формы',
            'simpleDialogs': 'Простые диалоги',
            'responsiveFullScreen': 'Отзывчивый полный экран',
            'primary': 'первичный',
            'social': 'Социальное',
            'user': 'пользователь',
            'admin': 'Администратор',
            'permanentdrawer': 'Постоянный ящик',
            'persistentdrawer': 'Постоянный ящик',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': 'Горизонтальная линейная альтернативная метка',
            'horizontalNonLinearAlternativeLabel': 'Горизонтальная нелинейная альтернативная метка',
            'notifications': 'Уведомления',
            'basicAlert': 'Основное оповещение',
            'successAlert': 'Успешное предупреждение',
            'warningAlert': 'Предупреждающее предупреждение',
            'reactAutoSuggest': 'Реагировать Авто Предложить',
            'components': 'Компоненты',
            'inputAdornments': 'Входные адепты',
            'multiSelectList': 'много Выбрать список',
            'contextualColoredTable': 'Контекстная цветная таблица',
            'updateYourEmailAddress': 'Обновить адрес электронной почты',
            'selectADefaultAddress': 'Выберите адрес по умолчанию',
            'activity': 'Мероприятия',
            'basicCalendar': 'Основной календарь',
            'culturesCalendar': 'Календарь культур',
            'dragAndDropCalendar': 'Календарь перетаскивания',
            'quillEditor': 'Редактор Quill',
            'reactDND': 'Реакция DND',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': 'Принять или отклонить',
            'quoteOfTheDay': 'Цитата дня',
            'updated10Minago': 'Обновлено 10 мин назад',
            'personalSchedule': 'Персональный график',
            'activeUsers': 'Активные пользователи',
            'totalRequest': 'Общий запрос',
            'new': 'новый',
            'ShareWithFriends': 'Поделиться с друзьями!',
            'helpToShareText': 'Помогите нам распространить мир, поделившись нашим сайтом со своими друзьями и последователями в социальных сетях!',
            'thisWeek': 'На этой неделе',
            'howWouldYouRateUs': 'Как вы оцениваете нас?',
            'booking': 'бронирование',
            'confirmed': 'подтвердил',
            'monthly': 'ежемесячно',
            'weekly': 'еженедельно',
            'target': 'цель',
            'totalActiveUsers': 'Всего активных пользователей',
            'deadline': 'Крайний срок',
            'team': 'команда',
            'projectManagement': 'Управление проектом',
            'latestPost': 'Последний пост',
            'projectTaskManagement': 'Управление проектами',
            'selectProject': 'Выберите проект',
            'activityBoard': 'Доска объявлений',
            'checklist': 'контрольный список',
            'baseConfig': 'Базовая конфигурация',
            'customControlBar': 'Пользовательская панель управления',
            'withDownloadButton': 'С кнопкой загрузки',
            'httpLiveStreaming': 'HTTP потоковое видео',
            'keyboardShortcuts': 'Горячие клавиши',
            'preview': 'предварительный просмотр',
            'croppedImage': 'Обрезанное изображение',
            'transactionList': 'список транзакций',
            'transferReport': 'отчет о передаче',
            'expenseCategory': 'категория расходов',
            'upcomingEvents': 'Предстоящие События',
            'OngoingProjects': 'текущие проекты',
            'ProjectStatus': 'статус проекта',
            'LiveChatSupport': 'поддержка в чате'
        },
        'components': {
            'buyNow': 'купить сейчас',
            'alreadyHavingAccountSignIn': 'У вас уже есть учетная запись',
            'enterYourPassword': 'Введите ваш пароль',
            'unlock': 'отпереть',
            'enterPasswords': 'Введите пароли',
            'resestPassword': 'Пароль Resest',
            'pageNotfound': 'Страница не найдена',
            'goToHomePage': 'Вернуться на домашнюю страницу',
            'sorryServerGoesWrong': 'К сожалению, сервер не работает',
            'persistentDrawer': 'Постоянный ящик',
            'back': 'назад',
            'next': 'следующий',
            'completeStep': 'Полный шаг',
            'withHtml': 'С Html',
            'prompt': 'Незамедлительный',
            'withDescription': 'С описанием',
            'success': 'успех',
            'passwordPrompt': 'Запрос пароля',
            'warning': 'Предупреждение',
            'customIcon': 'Пользовательский значок',
            'customStyle': 'Пользовательский стиль',
            'basic': 'основной',
            'submit': 'Отправить',
            'sendMessage': 'Отправить сообщение',
            'addNewTasks': 'Добавить новые задачи',
            'addToCart': 'Добавить в корзину',
            'payNow': 'Заплатить сейчас',
            'print': 'Распечатать',
            'cart': 'телега',
            'viewCart': 'Просмотр корзины',
            'checkout': 'Проверять, выписываться',
            'summary': 'Резюме',
            'yesterday': 'Вчера',
            'last7Days': 'Последние 7 дней',
            'last1Month': 'Последние 1 месяц',
            'last6Month': 'Последние 6 месяцев',
            'spaceUsed': 'Используемое пространство',
            'followers': 'толкатель',
            'trending': 'простирания',
            'paid': 'оплаченный',
            'refunded': 'Возвращено',
            'done': 'Готово',
            'pending': 'в ожидании',
            'cancelled': 'отменен',
            'approve': 'Одобрить',
            'week': 'Неделю',
            'month': 'Месяц',
            'year': 'Год',
            'today': 'Cегодня',
            'popularity': 'популярность',
            'email': 'Эл. адрес',
            'drafts': 'Черновики',
            'sent': 'Отправлено',
            'trash': 'дрянь',
            'all': 'Все',
            'do': 'Делать',
            'title': 'заглавие',
            'projectName': 'название проекта',
            'companyName': 'название компании',
            'openAlert': 'Открыть оповещение',
            'slideInAlertDialog': 'Слайд в диалоговом окне оповещений',
            'openFullScreenDialog': 'Открыть полноэкранные диалоги',
            'basicChip': 'Основной чип',
            'clickableChip': 'Кликаемый чип',
            'left': 'Оставил',
            'right': 'Правильно',
            'expansionPanel1': 'Панель расширения 1',
            'expansionPanel2': 'Панель расширения 2',
            'generalSetting': 'Общая настройка',
            'advancedSettings': 'Расширенные настройки',
            'firstName': 'Имя',
            'lastName': 'Фамилия',
            'occupation': 'оккупация',
            'phoneNo': 'Номер телефона',
            'address': 'Адрес',
            'city': 'город',
            'state': 'состояние',
            'zipCode': 'Почтовый Индекс',
            'social Connection': 'Социальная связь',
            'emailPrefrences': 'Настройки электронной почты',
            'myProfile': 'Мой профайл',
            'product': 'Продукт',
            'quantity': 'Количество',
            'totalPrice': 'Итоговая цена',
            'removeProduct': 'Удалить продукт',
            'mobileNumber': 'Мобильный номер',
            'address2Optional': 'Адрес 2 (необязательно)',
            'country': 'Страна',
            'zip': 'застежка-молния',
            'saveContinue': 'Сохранить и продолжить',
            'placeOrder': 'Разместить заказ',
            'payment': 'Оплата',
            'billingAddress': 'Платежный адрес',
            'ShippingAddressText': 'Адрес доставки совпадает с адресом фактуры.',
            'CartEmptyText': 'Ваша корзина пуста!',
            'NoItemFound': 'Не найдено ни одного товара',
            'goToShop': 'Идти в магазин',
            'cardNumber': 'Номер карты',
            'expiryDate': 'Срок годности',
            'cvv': 'CVV',
            'nameOnCard': 'Имя на карте',
            'confirmPayment': 'Подтвердить платеж'
        },
        'compenets': {
            'choose': 'выберите',
            'username': 'имя пользователя',
            'passwords': 'Пароли',
            'signIn': 'Войти в систему',
            'dontHaveAccountSignUp': 'У вас нет учетной записи Зарегистрироваться',
            'enterUserName': 'Введите имя пользователя',
            'enterEmailAddress': 'Введите адрес электронной почты',
            'confirmPasswords': 'Подтвердить пароли'
        },
        'themeOptions': {
            'sidebarOverlay': 'Наложение боковой панели',
            'sidebarBackgroundImages': 'Фоновые изображения боковой ',
            'miniSidebar': 'Мини-боковая панель',
            'boxLayout': 'Макет коробки',
            'rtlLayout': 'Rtl расположение',
            'darkMode': 'Темный режим',
            'sidebarImage': 'Изображение боковой панели',
            'appSettings': 'Настройки приложения',
            'sidebarLight': 'Легкий',
            'sidebarDark': 'Темно',
            'themeColor': 'Цвет темы'
        },
        'button': {
            'cancel': 'Отмена',
            'add': 'Добавить',
            'update': 'Обновить',
            'reply': 'Ответить',
            'delete': 'Удалить',
            'yes': 'да',
            'viewAll': 'Посмотреть все',
            'like': 'подобно',
            'assignNow': 'Назначить сейчас',
            'seeInsights': 'См. Insights',
            'acceptTerms': 'Принять условия',
            'reject': 'отклонять',
            'addNew': 'Добавить новое',
            'goToCampaign': 'Перейти в кампанию',
            'viewProfile': 'Просмотреть профиль',
            'sendMessage': 'Отправить сообщение',
            'saveNow': 'Сохрани теперь',
            'pen': 'Ручка',
            'search': 'Поиск',
            'downloadPdfReport': 'Загрузить отчет Pdf',
            'primary': 'первичный',
            'secondary': 'второстепенный',
            'danger': 'Опасность',
            'info': 'Информация',
            'success': 'успех',
            'warning': 'Предупреждение',
            'link': 'Link',
            'smallButton': 'Маленькая кнопка',
            'largeButton': 'Большая кнопка',
            'blockLevelButton': 'Кнопка уровня блока',
            'primaryButton': 'Основная кнопка',
            'button': 'кнопка',
            'save': 'Сохранить',
            'openMenu': 'Открыть меню',
            'openWithFadeTransition': 'Открыть с переходом увядать',
            'openPopover': 'Открыть трещать',
            'accept': 'принимать',
            'click': 'Нажмите',
            'complete': 'полный',
            'back': 'назад',
            'next': 'следующий',
            'completeStep': 'Полный шаг',
            'error': 'ошибка',
            'writeNewMessage': 'Написать новое сообщение',
            'saveChanges': 'Сохранить изменения',
            'addNewUser': 'Добавить пользователя',
            'more': 'Больше',
            'useDefaultImage': 'Использовать изображение по умолчанию',
            'cropImage': 'Обрезать изображение'
        },
        'hint': {
            'whatAreYouLookingFor': 'Что ты ищешь',
            'searchMailList': 'Поиск в списке рассылки'
        },
        'module': {
            'inbox': 'входящие',
            'drafts': 'Черновики',
            'sent': 'Отправлено',
            'trash': 'дрянь',
            'spam': 'Спам',
            'frontend': 'Внешний интерфейс',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'вопрос'
        },
        'documents': {},
        'common': {
            actions: {
                prev: 'Пред',
                next: 'След'
            }
        },
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};
